// extracted by mini-css-extract-plugin
export default {"scriptWrapper":"ScriptWrapper_scriptWrapper__2mNHC"};